import { all, call, fork, put, takeLatest } from "typed-redux-saga";
import { Action, ralColorActions } from "./ral-colors-store";
import { errorActions as errorActions } from "src/components/error-viewer/error-store";
import { RalColorService } from "src/backend/openapi/v1";

// the picker only ever dispatches the request action once its own Loading<T> hasn't started,
// so takeLatest here is just the standard read-saga convention rather than a de-dupe mechanism
export function* getRalColorsRequest() {
  try {
    const result = yield* call(RalColorService.getApiV1RalColors);
    yield put(ralColorActions.getRalColorsSuccess(result));
  } catch (error) {
    yield put(errorActions.addError(error));
    yield put(ralColorActions.getRalColorsFailure());
  }
}

export function* watchGetRalColorsRequest() {
  yield takeLatest(Action.GetRalColorsRequest, getRalColorsRequest);
}

export function* ralColorsSaga() {
  yield all([fork(watchGetRalColorsRequest)]);
}
